import React, { useState, useRef, useEffect } from 'react';

const LEVEL_COLOR = {
  OK:       '#4ADE80',
  INFO:     '#22D3EE',
  WARN:     '#FCD34D',
  ERROR:    '#F87171',
  DOWN:     '#F87171',
  RECOVERY: '#4ADE80',
};

export default function LogTerminal({ logs }) {
  const [filter,  setFilter]  = useState('all');
  const [search,  setSearch]  = useState('');
  const [paused,  setPaused]  = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (!paused) bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs, paused]);

  const displayed = logs.filter((l) => {
    if (filter !== 'all' && l.level !== filter) return false;
    if (search && !l.message?.toLowerCase().includes(search.toLowerCase())
               && !l.service?.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div>
      {/* Toolbar */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 10, flexWrap: 'wrap',
                    alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={filter} onChange={(e) => setFilter(e.target.value)}
            style={{ fontSize: 11, padding: '4px 10px', border: '1px solid #E2E8F0',
                     borderRadius: 6, color: '#64748B', background: '#fff' }}>
            <option value="all">Tous niveaux</option>
            <option value="ERROR">ERROR</option>
            <option value="DOWN">DOWN</option>
            <option value="WARN">WARN</option>
            <option value="OK">OK</option>
            <option value="RECOVERY">RECOVERY</option>
          </select>
          <input value={search} onChange={(e) => setSearch(e.target.value)}
            placeholder="🔍 Rechercher…"
            style={{ fontSize: 11, padding: '4px 10px', border: '1px solid #E2E8F0',
                     borderRadius: 6, color: '#64748B', background: '#fff', minWidth: 200 }} />
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => setPaused((p) => !p)}
            style={{ background: '#2563EB', color: '#fff', border: 'none',
                     borderRadius: 6, padding: '4px 12px', fontSize: 11,
                     fontWeight: 600, cursor: 'pointer' }}>
            {paused ? '▶ Reprendre' : '⏸ Pause'}
          </button>
        </div>
      </div>

      {/* Terminal */}
      <div style={{ background: '#0F172A', borderRadius: 9, height: 400,
                    overflowY: 'auto', padding: 12,
                    fontFamily: "'Courier New', monospace", fontSize: 11 }}>
        {displayed.length === 0 ? (
          <div style={{ color: '#475569', textAlign: 'center', marginTop: 40 }}>
            Aucun log correspondant au filtre
          </div>
        ) : (
          displayed.map((log, i) => (
            <div key={i} style={{ display: 'flex', gap: 10, padding: '2px 0',
                                  borderBottom: '1px solid rgba(255,255,255,.04)',
                                  alignItems: 'baseline' }}>
              <span style={{ color: '#475569', flexShrink: 0, width: 75 }}>
                {log.ts ? new Date(log.ts).toLocaleTimeString('fr-FR') : '--:--:--'}
              </span>
              <span style={{ color: '#7C3AED', flexShrink: 0, width: 100,
                             fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {(log.service || '').substring(0, 14)}
              </span>
              <span style={{ flexShrink: 0, width: 70,
                             color: LEVEL_COLOR[log.level] || '#CBD5E1',
                             fontWeight: 700, fontSize: 10 }}>
                {log.level}
              </span>
              <span style={{ color: '#CBD5E1', wordBreak: 'break-all' }}>
                {log.message}
              </span>
            </div>
          ))
        )}
        <div ref={bottomRef} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between',
                    marginTop: 8, fontSize: 10, color: '#94A3B8' }}>
        <span>{displayed.length} entrée(s) affichée(s)</span>
        <span>Auto-scroll {paused ? 'désactivé' : 'activé'} • Rétention 300 entrées</span>
      </div>
    </div>
  );
}
